import React from 'react'

function Footer() {
  return (
    <div className='footer-container'>
        <div className='footer-info'>
            <h4>Dane kontaktowe</h4>
            <p>Adres : Cracow Poland </p>
            <p>Telefon : 000-000-000 </p>
            <p>Email : marcinoles87@gmail.com</p>
        </div>

        <div className='footer-info'>
            <h4>Społeczność</h4>
            <p>Informacje</p>
            <p>Dobre rady</p>
            <p>Blog</p>
            <p>Strony przyjazne</p>
            <p>Zaczytany Kraków</p>
        </div>

        <div className='footer-info'>
            <h4>Informajce</h4>
            <p>Dostępność</p>
            <p>Dane kontaktowe</p>
            <p>Polityka Prywatności</p>
            <p>O Nas</p>
            <p>FAQ wypożyczania</p>
        </div>
    </div>
  )
}

export default Footer